import { render, staticRenderFns } from "./Import.vue?vue&type=template&id=35cdd9ba&scoped=true&"
import script from "./Import.vue?vue&type=script&lang=js&"
export * from "./Import.vue?vue&type=script&lang=js&"
import style0 from "./Import.vue?vue&type=style&index=0&id=35cdd9ba&scoped=true&lang=stylus&"
import style1 from "./Import.vue?vue&type=style&index=1&id=35cdd9ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cdd9ba",
  null
  
)

export default component.exports